var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('item-list-component',{attrs:{"item-type":'myItemHold'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }